/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './resolveHandle.defs.js'
export { main as default } from './resolveHandle.defs.js'
